import history from '../history';

const goTo = path => history.push(path);
const goToExternal = (url) => {
    window.location.href = url;
};
const goToEmsLogin = () => goToExternal(process.env.REACT_APP_EMS_BASE_URL);
const goToLogin = () => {
    goToExternal(`${process.env.REACT_APP_ACCOUNT_BASE_URL}/login?service=e-cert&redirectPath=/home`);
};

const newTab = url => window.open(url);

// eslint-disable-next-line import/no-anonymous-default-export
export default { goTo, goToExternal, goToLogin, newTab, goToEmsLogin };
